import React, {useState} from 'react';
import NotesModal from './NotesModal';

import { useEyeconxStore } from "../../../store/eyeconxStore";
import bookingService from "../../../services/booking.service";
import Loading from "../../common/Loading";
import toast from "react-toastify";

const BookingPatientCard = ({request,bookingstatus,handleUpdate}) =>{
    const [copied, setCopied] = useState(null);
    const [showNotes, setShowNotes] = useState(false);
    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    // Format date for display
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    const handleCopy = (value, type) => {
        navigator.clipboard.writeText(value);
        setCopied(type);
        setTimeout(() => setCopied(null), 1500); // reset message after 1.5s
    };

    const updateBookingStatus = async (statusid) => {
        const updatedRequest = {
            ...request,
            status: statusid || 0,
        };

        try {
            const response = await bookingService.updateBookingRequests(clinicId, updatedRequest);

            // Only call handleUpdate after success
            if (response && response.status === 200) {
                handleUpdate();
            } else {
                console.error("Booking update failed:", response);
            }
        } catch (error) {
            console.error("Error updating booking:", error);
        }
    };

    return (
        <>
            <div className="card border-0">
                <div className="card-body">
                    {/* Header with patient info and status */}
                    <div className="d-flex justify-content-between align-items-start mb-3">
                        <div className="d-flex align-items-center">
                            <div className="avatar bg-primary text-white rounded-circle p-2 me-3">
                                {request.firstName?.charAt(0)}{request.lastName?.charAt(0) }

                            </div>
                            <div>
                                <h5 className="mb-0">
                                    {request?.firstName} {request?.lastName}
                                    {request?.preferredName && (
                                        <span className="text-muted ms-1">({request?.preferredName})</span>
                                    )}
                                    {request?.isNewPatient ?
                                        <span className="badge bg-info p-1 status-badge ms-2">New Patient</span>
                                        :
                                        <span className="badge bg-success p-1 status-badge ms-2">Existing Patient</span>
                                    }

                                </h5>
                                <div className="d-flex flex-column">
                                    <small className="text-muted">Created : {request?.createdAt}</small>
                                    <small className="text-muted">Modified : {request?.modifiedAt}</small>
                                
                                </div>
                                
                            </div>
                        </div>
                        <div>

                            <div className="d-flex flex-column align-items-center mb-1">
                                {/* Phone */}
                                <div className="d-flex align-items-center mb-1">
                                    <i className="bi bi-phone text-muted me-2"></i>
                                    <span>{request?.cellPhone}</span>
                                    <i
                                        className="bi bi-clipboard ms-2 text-primary"
                                        style={{ cursor: "pointer" }}
                                        title="Copy phone"
                                        onClick={() => handleCopy(request?.cellPhone, "phone")}
                                    ></i>
                                    {copied === "phone" && (
                                        <small className="text-success ms-1">Copied!</small>
                                    )}
                                </div>
                                {/* Home Phone */}
                                <div className="d-flex align-items-center mb-1">
                                    <i className="bi bi-house text-muted me-2"></i>
                                    <span>{request?.homePhone}</span>
                                    <i
                                        className="bi bi-clipboard ms-2 text-primary"
                                        style={{ cursor: "pointer" }}
                                        title="Copy phone"
                                        onClick={() => handleCopy(request?.homePhone, "homephone")}
                                    ></i>
                                    {copied === "homephone" && (
                                        <small className="text-success ms-1">Copied!</small>
                                    )}
                                </div>

                                {/* Email */}
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-envelope text-muted me-2"></i>
                                    <span>{request?.email}</span>
                                    <i
                                        className="bi bi-clipboard ms-2 text-primary"
                                        style={{ cursor: "pointer" }}
                                        title="Copy email"
                                        onClick={() => handleCopy(request?.email, "email")}
                                    ></i>
                                    {copied === "email" && (
                                        <small className="text-success ms-1">Copied!</small>
                                    )}
                                </div>

                            </div>
                        </div>

                    </div>
                    {/* Content section*/}
                    <div className="row mb-3">
                        <div className="col-md-7">
                            <h6 className="text-muted mb-1">Appointment Type</h6>
                            <p className="mb-3 bg-light p-2 rounded"> {request?.bookingAppointmentType?.apptType} ({request?.bookingAppointmentType?.timeSlot} minutes)</p>
                            <h6 className="text-muted mb-1">Reason for Visit</h6>
                            <p className="mb-3 bg-light p-2 rounded">{request?.reason}</p>
                            {request?.comments && request?.comments !== 'No Comments\n' && (
                                <>
                                    <h6 className="text-muted mb-1">Patient Comments</h6>
                                    <p className="mb-3 bg-light p-2 rounded">{request?.comments}</p>
                                </>
                            )}
                            {request?.clinicComments && (
                                <>
                                    <h6 className="text-muted mb-1">
                                        <i className="bi bi-chat me-1"></i>
                                        Clinic Notes
                                    </h6>
                                    <p className="mb-0 bg-info bg-opacity-10 p-2 rounded border-start border-info border-3">
                                        {request?.clinicComments}
                                    </p>
                                </>
                            )}
                        </div>
                        <div className="col-md-5">
                            <h6 className="text-muted mb-2">
                                <i className="bi bi-person-workspace me-1"></i>
                                Doctor
                            </h6>

                            <p className="mb-3 bg-light p-2 rounded">{request?.doctorName}</p>
                            <h6 className="text-muted mb-2">
                                <i className="bi bi-calendar me-1"></i>
                                Preferred Dates
                            </h6>
                            <div className="ms-2">
                                <p className="mb-3 bg-light p-2 rounded">
                                    <strong>1st Preference: </strong>
                                    {formatDate(request?.firstPreferredDate)} at {request?.firstPreferredTime}
                                </p>
                                <p className="mb-3 bg-light p-2 rounded">
                                    <strong>2nd Preference: </strong>
                                    {formatDate(request?.secondPreferredDate)} at {request?.secondPreferredTime}
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer d-flex justify-content-between align-items-center border-top pt-3">
                    <button className="btn btn-outline-primary btn-sm" onClick={()=>setShowNotes(true)}>
                        <i className="bi bi-pencil me-1"></i>
                        Add Notes
                    </button>
                    <div>
                        {/* Only show if bookingStatus is 0 or 1 */}
                        {(request.status === 0 || request.status === 1) && (
                            <button className="btn btn-success btn-sm me-2 text-white" onClick={()=>updateBookingStatus(2)}>
                                <i className="bi bi-check-circle me-1"></i>
                                Mark as Processed
                            </button>
                        )}

                        {/* Only show if bookingStatus is 0 */}
                        {request.status === 0 && (
                            <button className="btn btn-warning btn-sm me-2 text-white" onClick={()=>updateBookingStatus(1)}>
                                <i className="bi bi-clock-history me-1"></i>
                                Follow Up Later
                            </button>
                        )}
                    </div>

                </div>
            </div>

            <NotesModal
                show = {showNotes}
                onClose = {()=>setShowNotes(false)}
                patientBooking = {request}
                handleUpdate = {handleUpdate}
            />
        </>
    );
}

export default BookingPatientCard;